<script>
/**
 * Reset Password component
 */
import {
    ValidationObserver,
    ValidationProvider,
    localize,
    extend,
} from "vee-validate";
import * as rules from "vee-validate/dist/rules";
import ja from "vee-validate/dist/locale/ja";
import axios from "axios";

// ルール設定
for (let rule in rules) {
    extend(rule, rules[rule]);
}
// 日本語化
localize("ja", ja);

export default {
    components: {
        ValidationObserver,
        ValidationProvider,
    },
    data() {
        return {
            email: "", // メールアドレス
            password: "", // 新しいパスワード
            password_confirmation: "", // パスワード確認
            isResetError: false, // エラー状態
            resetSuccess: false, // 成功状態
            error: "", // エラーメッセージ
        };
    },
    mounted() {
        const params = new URLSearchParams(window.location.search);
        const token = params.get("token");

        if (token) {
            // トークンに対応するメールアドレスを取得
            axios
                .get(`/api/users/token`, { params: { token } })
                .then((response) => {
                    this.email = response.data.email; // メールアドレスを設定
                })
                .catch((error) => {
                    console.error("Error fetching email:", error);
                    this.isResetError = true;
                    this.error = "トークンが無効です"; // エラーメッセージを設定
                });
        } else {
            console.error("Token not found in URL");
            this.isResetError = true;
            this.error = "トークンが無効です"; // エラーメッセージを設定
        }
    },
    computed: {
        rules() {
            return {
                required: true,
                min: 8,
                confirmed: "confirm", // パスワード確認用
            };
        },
    },
    methods: {
        async handleReset(event) {
            event.preventDefault(); // デフォルトのフォーム送信を防止
            this.isResetError = false;
            this.resetSuccess = false;

            try {
                // APIリクエストを送信
                const response = await axios.post("/api/password/reset", {
                    email: this.email,
                    password: this.password,
                    password_confirmation: this.password_confirmation,
                });

                // 成功時の処理
                this.resetSuccess = true;
                console.log("Password reset successfully:", response.data);

                // 入力欄を空にする
                this.email = "";

                // 5秒待機してログイン画面へリダイレクト
                setTimeout(() => {
                    window.location.href = "/login"; // ログイン画面のURLにリダイレクト
                }, 5000);
            } catch (error) {
                // エラーハンドリング
                this.isResetError = true;
                if (error.response && error.response.data && error.response.data.message) {
                    this.error = error.response.data.message;
                } else {
                    this.error = "パスワードリセット中にエラーが発生しました。";
                }
                console.error("Error during password reset:", error);
            }
        },
    },
};
</script>

<template>
    <div class="row justify-content-center">
        <div class="col-md-8 col-lg-6 col-xl-5">
            <div class="card overflow-hidden mt-2">
                <div class="card-body pt-0">
                    <!-- 成功メッセージ -->
                    <b-alert v-model="resetSuccess" class="mt-3" variant="success" dismissible>
                        Password reset successful.
                    </b-alert>
                    <!-- エラーメッセージ -->
                    <b-alert v-model="isResetError" class="mt-3" variant="danger" dismissible>
                        {{ error }}
                    </b-alert>
                    <h3 class="ps-2 pt-2 mt-4">Reset Password</h3>
                    <ValidationObserver v-slot="{ invalid }">
                        <b-form class="p-2 mt-3" @submit="handleReset" autocomplete="off">
                            <!-- メールアドレス -->
                            <b-form-group label="Email" label-for="email" class="mb-3">
                                <ValidationProvider name="Email" rules="required|email" v-slot="{ errors }">
                                    <b-form-input id="email" v-model="email" name="email" type="email"
                                        placeholder="Email is not editable" autocomplete="off" disabled></b-form-input>
                                    <p class="text-danger">{{ errors[0] }}</p>
                                </ValidationProvider>
                            </b-form-group>

                            <!-- 新しいパスワード -->
                            <b-form-group label="Password" label-for="password" class="mb-3">
                                <ValidationProvider name="Password" :rules="rules" v-slot="{ errors }">
                                    <b-form-input id="password" v-model="password" name="password" type="password"
                                        placeholder="Enter your password" autocomplete="new-password"></b-form-input>
                                    <p class="text-danger">{{ errors[0] }}</p>
                                </ValidationProvider>
                            </b-form-group>

                            <!-- パスワード確認 -->
                            <b-form-group label="Confirm Password" label-for="password-confirm" class="mb-3">
                                <ValidationProvider name="Confirm Password" rules="" vid="confirm" v-slot="{ errors }">
                                    <b-form-input id="password-confirm" v-model="password_confirmation"
                                        name="password_confirmation" type="password" placeholder="Confirm your password"
                                        autocomplete="off"></b-form-input>
                                    <p class="text-danger">{{ errors[0] }}</p>
                                </ValidationProvider>
                            </b-form-group>

                            <div class="form-group row mb-0">
                                <div class="col-12 text-end">
                                    <button class="btn btn-primary w-md" type="submit"
                                        :disabled="invalid">Reset</button>
                                </div>
                            </div>
                        </b-form>
                    </ValidationObserver>
                </div>
                <!-- end card-body -->
            </div>
            <!-- end card -->

            <div class="mt-5 text-center">
                <p>© {{ new Date().getFullYear() }} Avalon Technologies, Inc.</p>
            </div>
        </div>
        <!-- end col -->
    </div>
</template>